import React from "react";
import Input from "./Input";
import Button from "./Button";

const InputButton = React.forwardRef((props, ref) => (
	<div className="input--button-group" style={{ position: "relative" }}>
		<Input
			{...props}
			ref={ref}
			{...(props.loading && { loading: !props.hideInputLoading })}
		/>
		{props.onClick && (
			<div
				style={{
					position: "absolute",
					transform: "translateY(-50%)",
					top: `calc(50% + ${
						props.buttonTop ? props.buttonTop : props.label ? "15px" : "1px"
					})`,
					right: `${props.buttonRight || "5px"}`,
				}}
			>
				<Button
					type={props.buttonType || "primary"}
					text={props.buttonText || "Update"}
					noMargin={true}
					size={props.buttonSize || "small"}
					disabled={props.disableButton}
					loading={props.loading}
					onClick={props.onClick}
				/>
			</div>
		)}
	</div>
));

export default InputButton;
